import React, { useState, useEffect } from "react";
import Breadcrumbs, { breadcrumbNameMap } from "../component/Breadcrumbs";
import { useLocation } from "react-router-dom";
import { usePreference } from "../context/PreferenceContext";

const GlobalHeader = ({ title, extra, children }) => {
    const location = useLocation();
    const { t } = usePreference();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Get title from mapping if not provided explicitly or as a fallback
    const rawMapped = breadcrumbNameMap[location.pathname];
    const mappedTitle = rawMapped ? t(rawMapped) : null;
    const finalTitle = title || mappedTitle || "Nearzon";

    return (
        <div className={`pcu-w-100 ${isMobile ? '' : 'global-header-wrapper'}`} style={isMobile ? { margin: '-16px -16px 0 -16px', width: 'auto' } : {}}>
            {!isMobile && (
                <div className="pcu-margin-bottom-16 breadcrumb-container">
                    <Breadcrumbs />
                </div>
            )}
            <div 
                className={`main-content-card pcu-bg-white pcu-overflow-hidden ${isMobile ? '' : 'pcu-radius-16 pcu-shadow-sm'}`}
                style={isMobile ? { borderRadius: 0, boxShadow: 'none' } : {}}
            >
                {!isMobile && (
                    <div className="pcu-border-bottom pcu-flex pcu-justify-between pcu-items-center" style={{ padding: '24px 24px 16px 24px' }}>
                        <h1 className="pcu-font-22 pcu-font-700 pcu-color-title pcu-margin-0">{finalTitle}</h1>
                        {extra && <div className="header-extra">{extra}</div>}
                    </div>
                )}
                <div style={{ padding: isMobile ? '8px 8px 80px 8px' : '24px' }}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default GlobalHeader;
